module.exports = __webpack_public_path__ + "img/wizard-back.9b48fdb5.svg";